import { ScanProgress } from 'fitbeat.models';
import React from 'react';
import { translate } from 'react-i18next';
import { Linking, ScrollView, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { Button, ButtonTypes } from '../../components';
import theme from '../../theme';
import Theme from '../../theme';
import { ExclamationIcon } from '../../ui/components/Icons';
import { defaultScale } from '../../utils/scaling';
import { IBodyScanError } from '../actions';
import { default as BodyscaleInfo } from './bodyscale-info';

interface IProps {
    t: (key: string) => string;
    progress: ScanProgress;
    status: string;
    error: IBodyScanError;
    startScan(): void;
}

class BodyscaleScanError extends React.PureComponent<IProps, any> {

    constructor(props: IProps) {
        super(props);
    }

    public render() {
        const { t, startScan, error } = this.props;
        return (
            <View style={styles.container}>
                <ScrollView contentContainerStyle={{flexGrow: 1}}>
                    <View style={{flex: 1, justifyContent: 'flex-end', marginBottom: defaultScale(30)}}>
                        <View style={{flex: 1, justifyContent: 'center'}}>
                            <View style={styles.iconContainer}>
                                <ExclamationIcon color={Theme.CHARCOAL} borderColor={Theme.CHARCOAL} />
                            </View>
                            <Text style={[styles.errorInstructionText, { color: theme.CHARCOAL }]}>
                                {t('cannotConnect')}
                            </Text>
                            <Text style={styles.errorDescriptionText}>
                                {error.message}
                            </Text>
                            {error.type === 'Permission' &&
                              <Button
                                  buttonType={ButtonTypes.TRANSPARENT}
                                  title={t('enableInAppSettings')}
                                  onPress={Linking.openSettings}
                              />
                            }
                        </View>
                        <BodyscaleInfo activeSection={1} />
                    </View>
                </ScrollView>
                <View style={styles.footer}>
                    <Button
                        title='Try again'
                        onPress={() => startScan()}
                        fontColor={theme.PRIMARY}
                        buttonType={ButtonTypes.OUTLINE}
                        containerStyle={[styles.submitButtonContainer]}
                    />
                </View>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    iconContainer: {
        paddingVertical: defaultScale(25),
        alignSelf: 'center',
    },
    submitButtonContainer: {
        marginVertical: defaultScale(5),
    },
    errorDescriptionText: {
        ...theme.textStyle.bodyCopyReg,
        color: theme.GREY_DARK_MEDIUM,
        paddingTop: defaultScale(10),
        letterSpacing: 0,
        textAlign: 'center',
    },
    errorInstructionText: {
        ...theme.textStyle.heading,
        alignSelf: 'center',
        textAlign: 'center',
    },
    footer: {
        justifyContent: 'flex-end',
    },
});

export default translate(['bodyscan'])(BodyscaleScanError);
